import { Component, Inject, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { CardActions } from '../../user.model';
import { UserCardRequestFormData } from '../../forms/user-card-request-detail-form/user-card-request-detail-form.component';

@Component({
    selector: 'app-user-card-request-detail-dialog',
    templateUrl: './user-card-request-detail-dialog.component.html',
    styleUrls: ['./user-card-request-detail-dialog.component.scss'],
})
export class UserCardRequestDetailDialogComponent implements OnDestroy {
    public destroy$ = new Subject();

    CardActions = CardActions;

    @Output() approvalPressed = new EventEmitter<{ userId: string; cardId: string }>();

    constructor(
        private dialogRef: MatDialogRef<UserCardRequestDetailDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: UserCardRequestFormData,
    ) {}

    closeDialog(value?: boolean): void {
        this.dialogRef.close(value);
    }

    onApprovalPressed(event: { userId: string; cardId: string }): void {
        this.approvalPressed.emit(event);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
